// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Reports-module__font-s-10___pBhH3 {
  font-size: 10px !important;
}

.Reports-module__font-s-12___tIxag {
  font-size: 12px !important;
}

.Reports-module__font-s-13___R0hk0 {
  font-size: 13px !important;
}

.Reports-module__font-s-14___MeGVl {
  font-size: 14px !important;
}

.Reports-module__font-s-15___aW2R4 {
  font-size: 15px !important;
}

.Reports-module__font-s-16___QX70a {
  font-size: 16px !important;
}

.Reports-module__font-s-18___BqoKQ {
  font-size: 18px !important;
}

.Reports-module__font-s-20___V7xVM {
  font-size: 20px !important;
}

.Reports-module__font-s-22___is4R8 {
  font-size: 22px !important;
}

.Reports-module__font-s-28___OKafp {
  font-size: 28px !important;
}

.Reports-module__font-w-400___p3pWk {
  font-weight: 400 !important;
}

.Reports-module__font-w-500___LramT {
  font-weight: 500 !important;
}

.Reports-module__font-w-600___dQ771 {
  font-weight: 600 !important;
}

.Reports-module__font-w-700___u2VQ2 {
  font-weight: 700 !important;
}

.Reports-module__p-5___FFHzB {
  padding: 5px !important;
}

.Reports-module__p-12___Tw3vL {
  padding: 12px !important;
}

.Reports-module__p-16___zzORf {
  padding: 16px !important;
}

.Reports-module__p-30___JFGj9 {
  padding: 30px !important;
}

.Reports-module__p-b-0___aRl2K {
  padding-bottom: 0 !important;
}

.Reports-module__p-b-5___N96kF {
  padding-bottom: 5px !important;
}

.Reports-module__p-b-10___KJ1tw {
  padding-bottom: 10px !important;
}

.Reports-module__p-b-12___SJpkj {
  padding-bottom: 12px !important;
}

.Reports-module__p-b-16___zV8vC {
  padding-bottom: 16px !important;
}

.Reports-module__p-b-18___WRVig {
  padding-bottom: 18px !important;
}

.Reports-module__p-b-20___wJZ8C {
  padding-bottom: 20px !important;
}

.Reports-module__p-b-25___j9IE7 {
  padding-bottom: 25px !important;
}

.Reports-module__p-b-30___gbl5m {
  padding-bottom: 30px !important;
}

.Reports-module__p-b-50___CRgwr {
  padding-bottom: 50px !important;
}

.Reports-module__p-t-0___ZjhGd {
  padding-top: 0 !important;
}

.Reports-module__p-t-12___tfs08 {
  padding-top: 12px !important;
}

.Reports-module__p-t-16___DSGex {
  padding-top: 16px !important;
}

.Reports-module__p-t-18___OJxX0 {
  padding-top: 18px !important;
}

.Reports-module__p-t-20___nL0jj {
  padding-top: 20px !important;
}

.Reports-module__p-t-30___VUR17 {
  padding-top: 30px !important;
}

.Reports-module__p-t-40___k2elu {
  padding-top: 40px !important;
}

.Reports-module__p-t-50___r6A2G {
  padding-top: 50px !important;
}

.Reports-module__p-l-20___TI4JZ {
  padding-left: 20px !important;
}

.Reports-module__p-l-30___gcbYQ {
  padding-left: 30px !important;
}

.Reports-module__p-l-40___U2SfS {
  padding-left: 40px !important;
}

.Reports-module__p-r-16___MYuac {
  padding-right: 16px !important;
}

.Reports-module__p-r-20___ChjTG {
  padding-right: 20px !important;
}

.Reports-module__p-r-30___BnVwo {
  padding-right: 30px !important;
}

.Reports-module__p-r-50___eK86B {
  padding-right: 50px !important;
}

.Reports-module__p-r-60___T2kw3 {
  padding-right: 60px !important;
}

.Reports-module__m-b-1___fHrXa {
  margin-bottom: 1px !important;
}

.Reports-module__m-b-2___Hqz_l {
  margin-bottom: 2px !important;
}

.Reports-module__m-b-6___PtBQh {
  margin-bottom: 6px !important;
}

.Reports-module__m-b-8___uxHoV {
  margin-bottom: 8px !important;
}

.Reports-module__m-b-10___velKL {
  margin-bottom: 10px !important;
}

.Reports-module__m-b-14___iV3sM {
  margin-bottom: 14px !important;
}

.Reports-module__m-b-16___pFR1w {
  margin-bottom: 16px !important;
}

.Reports-module__m-b-20___LFW1g {
  margin-bottom: 20px !important;
}

.Reports-module__m-b-22___MFIQ5 {
  margin-bottom: 22px !important;
}

.Reports-module__m-b-24___MmV6m {
  margin-bottom: 24px !important;
}

.Reports-module__m-b-30___ivqtf {
  margin-bottom: 30px !important;
}

.Reports-module__m-b-32___vTnx_ {
  margin-bottom: 32px !important;
}

.Reports-module__m-b-40___wqGDA {
  margin-bottom: 40px !important;
}

.Reports-module__m-t-2___R8epS {
  margin-top: 2px !important;
}

.Reports-module__m-t-3___eRz8m {
  margin-top: 3px !important;
}

.Reports-module__m-t-4___qJkGJ {
  margin-top: 4px !important;
}

.Reports-module__m-t-5____Osq4 {
  margin-top: 5px !important;
}

.Reports-module__m-t-8___m3u99 {
  margin-top: 8px !important;
}

.Reports-module__m-t-10___Hdf3b {
  margin-top: 10px !important;
}

.Reports-module__m-t-15___JVa9W {
  margin-top: 15px !important;
}

.Reports-module__m-t-16___y7J8o {
  margin-top: 16px !important;
}

.Reports-module__m-t-20___MuXuZ {
  margin-top: 20px !important;
}

.Reports-module__m-t-22___LQbvq {
  margin-top: 22px !important;
}

.Reports-module__m-t-30___uG3ou {
  margin-top: 30px !important;
}

.Reports-module__m-t-32___VKWhq {
  margin-top: 32px !important;
}

.Reports-module__m-l-auto___rbGXN {
  margin-left: auto !important;
}

.Reports-module__m-l-4___Cl3wh {
  margin-left: 4px !important;
}

.Reports-module__m-l-5___OWJEr {
  margin-left: 5px !important;
}

.Reports-module__m-l-6___GBUWa {
  margin-left: 6px !important;
}

.Reports-module__m-l-8___yHW0m {
  margin-left: 8px !important;
}

.Reports-module__m-l-10___pXP0R {
  margin-left: 10px !important;
}

.Reports-module__m-l-16___dzt5J {
  margin-left: 16px !important;
}

.Reports-module__m-l-20___aeqfY {
  margin-left: 20px !important;
}

.Reports-module__m-l-24___HhoN6 {
  margin-left: 24px !important;
}

.Reports-module__m-l-30___R3BSY {
  margin-left: 30px !important;
}

.Reports-module__m-l-35___BBPK0 {
  margin-left: 35px !important;
}

.Reports-module__m-l-40___S1f0D {
  margin-left: 40px !important;
}

.Reports-module__m-r-8___VuXNf {
  margin-right: 8px !important;
}

.Reports-module__m-r-10___g8yRW {
  margin-right: 10px !important;
}

.Reports-module__m-r-16___ylcIt {
  margin-right: 16px !important;
}

.Reports-module__m-r-20___q4Nwt {
  margin-right: 20px !important;
}

.Reports-module__m-r-24___MvShl {
  margin-right: 24px !important;
}

.Reports-module__m-r-30___batIP {
  margin-right: 30px !important;
}

.Reports-module__m-r-40___bshcB {
  margin-right: 40px !important;
}

.Reports-module__border-r-3___hvxOV {
  border-radius: 3px !important;
}

.Reports-module__border-r-4___q5U6J {
  border-radius: 4px !important;
}

.Reports-module__border-r-6___h6eDA {
  border-radius: 6px !important;
}

.Reports-module__border-r-10___h3cWg {
  border-radius: 10px !important;
}

.Reports-module__border-r-12___lH4UL {
  border-radius: 12px !important;
}

.Reports-module__border-r-16___HJL5R {
  border-radius: 16px !important;
}

.Reports-module__border-r-50___rpdb3 {
  border-radius: 50% !important;
}

.Reports-module__primary-border___u5ys1 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Reports-module__primary-border-b___e1kdv {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Reports-module__primary-border-t___gBfJv {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Reports-module__primary-border-l___O_6Cy {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Reports-module__primary-border-r___Mg4bV {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Reports-module__secondary-border___Yeosn {
  border: 1px solid #637768;
}

.Reports-module__secondary-border-b___MxDWs {
  border-bottom: 1px solid #637768;
}

.Reports-module__secondary-border-t___ampq6 {
  border-top: 1px solid #637768;
}

.Reports-module__secondary-border-l___aUbIM {
  border-left: 1px solid #637768;
}

.Reports-module__secondary-border-r___oCgdv {
  border-right: 1px solid #637768;
}

.Reports-module__gap-0___AJght {
  gap: 0 !important;
}

.Reports-module__gap-2___MuraZ {
  gap: 2px !important;
}

.Reports-module__gap-4___WCBVT {
  gap: 4px !important;
}

.Reports-module__gap-5___EoI1m {
  gap: 5px !important;
}

.Reports-module__gap-6___fnoJu {
  gap: 6px !important;
}

.Reports-module__gap-8___rV21L {
  gap: 8px !important;
}

.Reports-module__gap-10___wl48j {
  gap: 10px !important;
}

.Reports-module__gap-12___KSLrR {
  gap: 12px !important;
}

.Reports-module__gap-14___qWnHg {
  gap: 14px !important;
}

.Reports-module__gap-16___bwGDw {
  gap: 16px !important;
}

.Reports-module__gap-18___dDGaf {
  gap: 18px !important;
}

.Reports-module__gap-20___gs1O0 {
  gap: 20px !important;
}

.Reports-module__gap-24___FRMCz {
  gap: 24px !important;
}

.Reports-module__gap-26___c4wyh {
  gap: 26px !important;
}

.Reports-module__gap-30___hDDin {
  gap: 30px !important;
}

.Reports-module__gap-32___bsHxY {
  gap: 32px !important;
}

.Reports-module__gap-40___BxZHC {
  gap: 40px !important;
}

.Reports-module__gap-50___fTHrA {
  gap: 50px !important;
}

.Reports-module__flex-1___tBygf {
  flex: 1;
}

.Reports-module__flex-none___H14lU {
  flex: none !important;
}

.Reports-module__flex-column___cyIS8 {
  display: flex;
  flex-direction: column !important;
}

.Reports-module__flex-row___TYTA9 {
  display: flex;
  flex-direction: row !important;
}

.Reports-module__vertically-centered____DQ2V {
  display: flex;
  align-items: center !important;
}

.Reports-module__horizontally-centered___zudO2 {
  display: flex;
  justify-content: center !important;
}

.Reports-module__horizontally-end___OpK0F {
  display: flex;
  justify-content: end !important;
}

.Reports-module__vertically-start____kKjb {
  display: flex;
  align-items: start !important;
}

.Reports-module__space-between___a3XuP {
  display: flex;
  justify-content: space-between !important;
}

.Reports-module__flex-wrap___Qllsm {
  flex-wrap: wrap !important;
}

.Reports-module__height-100___c7_8O {
  height: 100%;
}

.Reports-module__width-50___JAmJI {
  width: 50% !important;
}

.Reports-module__width-100___MCZ0M {
  width: 100%;
}

.Reports-module__cursor-pointer___BfpFc {
  cursor: pointer;
}

.Reports-module__cursor-not-allowed___BgyJ8 {
  cursor: not-allowed !important;
}

.Reports-module__absolute-centered___OkvZr {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Reports-module__absolute___aRRN7 {
  position: absolute;
}

.Reports-module__relative____DfPo {
  position: relative;
}

.Reports-module__fixed___nvn74 {
  position: fixed;
}

.Reports-module__visible___rMakB {
  opacity: 1;
}

.Reports-module__invisible___jJRAR {
  opacity: 0;
}

.Reports-module__col-90___p4pL7 {
  width: 90% !important;
}

.Reports-module__col-auto___RBsCW {
  width: auto !important;
}

.Reports-module__medical-tabs___ltN2A {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Reports-module__medical-table-new___tEQsY {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Reports-module__medical-table-new___tEQsY:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Reports-module__medical-table-new___tEQsY::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Reports-module__medical-table-new___tEQsY::-webkit-scrollbar-track {
  display: none;
}
.Reports-module__medical-table-new___tEQsY.Reports-module__no-pagination___o_rFT {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Reports-module__medical-table-new___tEQsY.Reports-module__no-pagination___o_rFT:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Reports-module__medical-table-new___tEQsY.Reports-module__no-pagination___o_rFT::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Reports-module__medical-table-new___tEQsY.Reports-module__no-pagination___o_rFT::-webkit-scrollbar-track {
  display: none;
}

.Reports-module__medical-table-empty___Xl6IN {
  padding: 14px 40px !important;
}

.Reports-module__icon-btn___vuk7h {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Reports-module__search-icon___pC2D7 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Reports-module__disable-select___k3p0Y {
  user-select: none;
}

.Reports-module__break-word___ebxi8 {
  word-break: break-word;
}

.Reports-module__popup-clear-btn___TGyv4 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Reports-module__scroll-m-b-20___vRCMm {
  scroll-margin-bottom: 20px;
}

.Reports-module__container____xAkC {
  height: calc(100vh - var(--tabs-navigation) - var(--secondary-navigation) - var(--patient-details-footer) - 50px);
  padding-top: 30px;
  padding-left: 30px;
  position: relative;
}
.Reports-module__container____xAkC .Reports-module__sectionTitle___adCnO {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #375844;
}
.Reports-module__container____xAkC .Reports-module__bulkDocTitle___xdQcf {
  font-size: 20px;
  font-weight: 600;
  margin-top: 40px;
  margin-bottom: 20px;
  color: #375844;
}
.Reports-module__container____xAkC .Reports-module__grid___QqPMd {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 300px;
}
.Reports-module__container____xAkC .Reports-module__buttonRow___hH0Ta {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.Reports-module__container____xAkC .Reports-module__buttonRow___hH0Ta button {
  white-space: nowrap;
}
.Reports-module__container____xAkC .Reports-module__note___n2Xbu {
  font-size: 14px;
  color: #859989;
  margin: 8px 0;
  font-weight: 500;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/Reports/Reports.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,iHAAA;EAGA,iBAAA;EACA,kBAAA;EACA,kBAAA;AA4pBF;AA1pBE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA4pBJ;AAzpBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA2pBJ;AAxpBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AA0pBJ;AAvpBE;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,2BAAA;AAypBJ;AAvpBI;EACE,mBAAA;AAypBN;AArpBE;EACE,eAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAupBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  height: calc(\n    100vh - var(--tabs-navigation) - var(--secondary-navigation) - var(--patient-details-footer) - 50px\n  );\n  padding-top: 30px;\n  padding-left: 30px;\n  position: relative;\n\n  .sectionTitle {\n    font-size: 20px;\n    font-weight: 600;\n    margin-bottom: 20px;\n    color: get-color(greenNew, dark);\n  }\n\n  .bulkDocTitle {\n    font-size: 20px;\n    font-weight: 600;\n    margin-top: 40px;\n    margin-bottom: 20px;\n    color: get-color(greenNew, dark);\n  }\n\n  .grid {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    max-width: 300px; \n  }\n\n  .buttonRow {\n    display: flex;\n    gap: 16px;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n\n    button {\n      white-space: nowrap;\n    }\n  }\n\n  .note {\n    font-size: 14px;\n    color: get-color(greenNew, medium);\n    margin: 8px 0;\n    font-weight: 500;\n    white-space: nowrap;\n  }\n\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Reports-module__font-s-10___pBhH3`,
	"fontS12": `Reports-module__font-s-12___tIxag`,
	"fontS13": `Reports-module__font-s-13___R0hk0`,
	"fontS14": `Reports-module__font-s-14___MeGVl`,
	"fontS15": `Reports-module__font-s-15___aW2R4`,
	"fontS16": `Reports-module__font-s-16___QX70a`,
	"fontS18": `Reports-module__font-s-18___BqoKQ`,
	"fontS20": `Reports-module__font-s-20___V7xVM`,
	"fontS22": `Reports-module__font-s-22___is4R8`,
	"fontS28": `Reports-module__font-s-28___OKafp`,
	"fontW400": `Reports-module__font-w-400___p3pWk`,
	"fontW500": `Reports-module__font-w-500___LramT`,
	"fontW600": `Reports-module__font-w-600___dQ771`,
	"fontW700": `Reports-module__font-w-700___u2VQ2`,
	"p5": `Reports-module__p-5___FFHzB`,
	"p12": `Reports-module__p-12___Tw3vL`,
	"p16": `Reports-module__p-16___zzORf`,
	"p30": `Reports-module__p-30___JFGj9`,
	"pB0": `Reports-module__p-b-0___aRl2K`,
	"pB5": `Reports-module__p-b-5___N96kF`,
	"pB10": `Reports-module__p-b-10___KJ1tw`,
	"pB12": `Reports-module__p-b-12___SJpkj`,
	"pB16": `Reports-module__p-b-16___zV8vC`,
	"pB18": `Reports-module__p-b-18___WRVig`,
	"pB20": `Reports-module__p-b-20___wJZ8C`,
	"pB25": `Reports-module__p-b-25___j9IE7`,
	"pB30": `Reports-module__p-b-30___gbl5m`,
	"pB50": `Reports-module__p-b-50___CRgwr`,
	"pT0": `Reports-module__p-t-0___ZjhGd`,
	"pT12": `Reports-module__p-t-12___tfs08`,
	"pT16": `Reports-module__p-t-16___DSGex`,
	"pT18": `Reports-module__p-t-18___OJxX0`,
	"pT20": `Reports-module__p-t-20___nL0jj`,
	"pT30": `Reports-module__p-t-30___VUR17`,
	"pT40": `Reports-module__p-t-40___k2elu`,
	"pT50": `Reports-module__p-t-50___r6A2G`,
	"pL20": `Reports-module__p-l-20___TI4JZ`,
	"pL30": `Reports-module__p-l-30___gcbYQ`,
	"pL40": `Reports-module__p-l-40___U2SfS`,
	"pR16": `Reports-module__p-r-16___MYuac`,
	"pR20": `Reports-module__p-r-20___ChjTG`,
	"pR30": `Reports-module__p-r-30___BnVwo`,
	"pR50": `Reports-module__p-r-50___eK86B`,
	"pR60": `Reports-module__p-r-60___T2kw3`,
	"mB1": `Reports-module__m-b-1___fHrXa`,
	"mB2": `Reports-module__m-b-2___Hqz_l`,
	"mB6": `Reports-module__m-b-6___PtBQh`,
	"mB8": `Reports-module__m-b-8___uxHoV`,
	"mB10": `Reports-module__m-b-10___velKL`,
	"mB14": `Reports-module__m-b-14___iV3sM`,
	"mB16": `Reports-module__m-b-16___pFR1w`,
	"mB20": `Reports-module__m-b-20___LFW1g`,
	"mB22": `Reports-module__m-b-22___MFIQ5`,
	"mB24": `Reports-module__m-b-24___MmV6m`,
	"mB30": `Reports-module__m-b-30___ivqtf`,
	"mB32": `Reports-module__m-b-32___vTnx_`,
	"mB40": `Reports-module__m-b-40___wqGDA`,
	"mT2": `Reports-module__m-t-2___R8epS`,
	"mT3": `Reports-module__m-t-3___eRz8m`,
	"mT4": `Reports-module__m-t-4___qJkGJ`,
	"mT5": `Reports-module__m-t-5____Osq4`,
	"mT8": `Reports-module__m-t-8___m3u99`,
	"mT10": `Reports-module__m-t-10___Hdf3b`,
	"mT15": `Reports-module__m-t-15___JVa9W`,
	"mT16": `Reports-module__m-t-16___y7J8o`,
	"mT20": `Reports-module__m-t-20___MuXuZ`,
	"mT22": `Reports-module__m-t-22___LQbvq`,
	"mT30": `Reports-module__m-t-30___uG3ou`,
	"mT32": `Reports-module__m-t-32___VKWhq`,
	"mLAuto": `Reports-module__m-l-auto___rbGXN`,
	"mL4": `Reports-module__m-l-4___Cl3wh`,
	"mL5": `Reports-module__m-l-5___OWJEr`,
	"mL6": `Reports-module__m-l-6___GBUWa`,
	"mL8": `Reports-module__m-l-8___yHW0m`,
	"mL10": `Reports-module__m-l-10___pXP0R`,
	"mL16": `Reports-module__m-l-16___dzt5J`,
	"mL20": `Reports-module__m-l-20___aeqfY`,
	"mL24": `Reports-module__m-l-24___HhoN6`,
	"mL30": `Reports-module__m-l-30___R3BSY`,
	"mL35": `Reports-module__m-l-35___BBPK0`,
	"mL40": `Reports-module__m-l-40___S1f0D`,
	"mR8": `Reports-module__m-r-8___VuXNf`,
	"mR10": `Reports-module__m-r-10___g8yRW`,
	"mR16": `Reports-module__m-r-16___ylcIt`,
	"mR20": `Reports-module__m-r-20___q4Nwt`,
	"mR24": `Reports-module__m-r-24___MvShl`,
	"mR30": `Reports-module__m-r-30___batIP`,
	"mR40": `Reports-module__m-r-40___bshcB`,
	"borderR3": `Reports-module__border-r-3___hvxOV`,
	"borderR4": `Reports-module__border-r-4___q5U6J`,
	"borderR6": `Reports-module__border-r-6___h6eDA`,
	"borderR10": `Reports-module__border-r-10___h3cWg`,
	"borderR12": `Reports-module__border-r-12___lH4UL`,
	"borderR16": `Reports-module__border-r-16___HJL5R`,
	"borderR50": `Reports-module__border-r-50___rpdb3`,
	"primaryBorder": `Reports-module__primary-border___u5ys1`,
	"primaryBorderB": `Reports-module__primary-border-b___e1kdv`,
	"primaryBorderT": `Reports-module__primary-border-t___gBfJv`,
	"primaryBorderL": `Reports-module__primary-border-l___O_6Cy`,
	"primaryBorderR": `Reports-module__primary-border-r___Mg4bV`,
	"secondaryBorder": `Reports-module__secondary-border___Yeosn`,
	"secondaryBorderB": `Reports-module__secondary-border-b___MxDWs`,
	"secondaryBorderT": `Reports-module__secondary-border-t___ampq6`,
	"secondaryBorderL": `Reports-module__secondary-border-l___aUbIM`,
	"secondaryBorderR": `Reports-module__secondary-border-r___oCgdv`,
	"gap0": `Reports-module__gap-0___AJght`,
	"gap2": `Reports-module__gap-2___MuraZ`,
	"gap4": `Reports-module__gap-4___WCBVT`,
	"gap5": `Reports-module__gap-5___EoI1m`,
	"gap6": `Reports-module__gap-6___fnoJu`,
	"gap8": `Reports-module__gap-8___rV21L`,
	"gap10": `Reports-module__gap-10___wl48j`,
	"gap12": `Reports-module__gap-12___KSLrR`,
	"gap14": `Reports-module__gap-14___qWnHg`,
	"gap16": `Reports-module__gap-16___bwGDw`,
	"gap18": `Reports-module__gap-18___dDGaf`,
	"gap20": `Reports-module__gap-20___gs1O0`,
	"gap24": `Reports-module__gap-24___FRMCz`,
	"gap26": `Reports-module__gap-26___c4wyh`,
	"gap30": `Reports-module__gap-30___hDDin`,
	"gap32": `Reports-module__gap-32___bsHxY`,
	"gap40": `Reports-module__gap-40___BxZHC`,
	"gap50": `Reports-module__gap-50___fTHrA`,
	"flex1": `Reports-module__flex-1___tBygf`,
	"flexNone": `Reports-module__flex-none___H14lU`,
	"flexColumn": `Reports-module__flex-column___cyIS8`,
	"flexRow": `Reports-module__flex-row___TYTA9`,
	"verticallyCentered": `Reports-module__vertically-centered____DQ2V`,
	"horizontallyCentered": `Reports-module__horizontally-centered___zudO2`,
	"horizontallyEnd": `Reports-module__horizontally-end___OpK0F`,
	"verticallyStart": `Reports-module__vertically-start____kKjb`,
	"spaceBetween": `Reports-module__space-between___a3XuP`,
	"flexWrap": `Reports-module__flex-wrap___Qllsm`,
	"height100": `Reports-module__height-100___c7_8O`,
	"width50": `Reports-module__width-50___JAmJI`,
	"width100": `Reports-module__width-100___MCZ0M`,
	"cursorPointer": `Reports-module__cursor-pointer___BfpFc`,
	"cursorNotAllowed": `Reports-module__cursor-not-allowed___BgyJ8`,
	"absoluteCentered": `Reports-module__absolute-centered___OkvZr`,
	"absolute": `Reports-module__absolute___aRRN7`,
	"relative": `Reports-module__relative____DfPo`,
	"fixed": `Reports-module__fixed___nvn74`,
	"visible": `Reports-module__visible___rMakB`,
	"invisible": `Reports-module__invisible___jJRAR`,
	"col90": `Reports-module__col-90___p4pL7`,
	"colAuto": `Reports-module__col-auto___RBsCW`,
	"medicalTabs": `Reports-module__medical-tabs___ltN2A`,
	"medicalTableNew": `Reports-module__medical-table-new___tEQsY`,
	"noPagination": `Reports-module__no-pagination___o_rFT`,
	"medicalTableEmpty": `Reports-module__medical-table-empty___Xl6IN`,
	"iconBtn": `Reports-module__icon-btn___vuk7h`,
	"searchIcon": `Reports-module__search-icon___pC2D7`,
	"disableSelect": `Reports-module__disable-select___k3p0Y`,
	"breakWord": `Reports-module__break-word___ebxi8`,
	"popupClearBtn": `Reports-module__popup-clear-btn___TGyv4`,
	"scrollMB20": `Reports-module__scroll-m-b-20___vRCMm`,
	"container": `Reports-module__container____xAkC`,
	"sectionTitle": `Reports-module__sectionTitle___adCnO`,
	"bulkDocTitle": `Reports-module__bulkDocTitle___xdQcf`,
	"grid": `Reports-module__grid___QqPMd`,
	"buttonRow": `Reports-module__buttonRow___hH0Ta`,
	"note": `Reports-module__note___n2Xbu`
};
module.exports = ___CSS_LOADER_EXPORT___;
